import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActionTabletHardwareEventItemComponent } from './action-tablet-hardware-event-item/action-tablet-barrier-hardware-event.component';
import { CommonLayoutModule, CommonTranslationModule, CommonUIElementsModule, CommonUIFieldsModule, CommonUIBasicModule } from '@sdbn/common';
import { ActionTabletModule, ActionTabletRegistryService } from '@sdbn/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatRippleModule } from '@angular/material/core';



@NgModule({
  declarations: [
    ActionTabletHardwareEventItemComponent
  ],
  imports: [
    CommonModule,
    ActionTabletModule,
    CommonLayoutModule,
    CommonUIFieldsModule,
    CommonUIElementsModule,
    CommonTranslationModule,
    ReactiveFormsModule,
    FormsModule,
    MatRippleModule,
    CommonUIBasicModule
],
  exports: [
    ActionTabletHardwareEventItemComponent

  ]
})
export class ActionTabletBarrierControlModule {

  constructor(actionTabletRegistryService: ActionTabletRegistryService) {

    actionTabletRegistryService.registerType('hardware-event', ActionTabletHardwareEventItemComponent);

  }

}
